import { http } from 'http';

export default {
  patchOperation: ({ guid, operations }) =>
    http.patch(`/operations/${guid}`, operations, {
      headers: {
        'content-type': 'application/json-patch+json'
      }
    })
};
